import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import getVisibleEntries from '../../selectors/entries';
import { selectEntryTotal, formattedEntriesTotal, positiveNumber } from '../../selectors/entriesTotal';
// import { editEntry, removeEntry } from '../../actions/entryActions';
// import PropTypes from 'prop-types';
// import EntryForm from './EntryForm';

export const EntriesSummary = ({ currentBalance }) => {

  return (
    <div>
      <Typography variant="display1">
          Current Balance

      </Typography>
      <Typography variant="display1" color={positiveNumber(currentBalance) ? 'primary' : 'secondary'}>
        {formattedEntriesTotal(currentBalance)}
      </Typography>
    </div>
  );
};

const mapStateToProps = ({ filters, entries }) => {
  const visibleEntries = getVisibleEntries(entries
  , filters);
  return {
    currentBalance: selectEntryTotal(entries) / 100,
    visibleEntries
  };
};

export default connect(mapStateToProps)(EntriesSummary);



// WEBPACK FOOTER //
// ./src/components/entries/EntriesSummary.js